import React from "react";
import CustomTypography from "../../typography";
import { InfoBoxProps } from "../types";

export default function InfoBoxContent(props: InfoBoxProps): React.JSX.Element {
  const { children } = props;
  return <CustomTypography variant="body2">{children}</CustomTypography>;
}
